<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    class="svg-icon"
  >
    <title id="icon-dashboard" lang="en">Dashboard icon</title>
    <defs>
      <path
        id="uhj9q9zm3a"
        d="M2 2v5h5V2H2zm17 9c.552 0 1 .448 1 1v7c0 .552-.448 1-1 1h-7c-.552 0-1-.448-1-1v-7c0-.552.448-1 1-1h7zM8 11c.552 0 1 .448 1 1v7c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1v-7c0-.552.448-1 1-1h7zm10 2h-5v5h5v-5zM7 13H2v5h5v-5zM8 0c.552 0 1 .448 1 1v7c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h7zm11 0c.552 0 1 .448 1 1v7c0 .552-.448 1-1 1h-7c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h7zm-1 2h-5v5h5V2z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <use :fill="color" fill-rule="nonzero" xlink:href="#uhj9q9zm3a" />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-dashboard",
  components: {},
})
export default class IconDashboard extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
</script>
